module.exports = __webpack_public_path__ + "img/products.04b1c5ac.png";